module.exports = __webpack_public_path__ + "img/alloy.c46622e.webp";